<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte"
    import PopupCornerIcon from "./PopupCornerIcon.svelte"
    import { AddEscapeStack } from "@utils/underhood/escape-key"
    const dispatch = createEventDispatcher()
    export let float = false

    onMount(() =>
        AddEscapeStack({
            fn: () => {
                dispatch("exit")
            },
            name: "PopupExit",
        }),
    )
</script>

<PopupCornerIcon
    {float}
    icon={"close"}
    label="Close"
    on:click={() => {
        dispatch("exit")
    }}
/>
